module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-475w.eda4fff7.webp";